import styled from '@xstyled/styled-components';

/**
 * Wrapper for image-map hotspots (button + optional `.drillBoxEffect` pulse).
 *
 * Focus indicator is three rings so it stays visible on any photo and any
 * brand (CAT-1371 / EL–E138): brand-or-black/white on the button fill, a
 * theme-surface gap, then the opposite theme colour. The pulse is painted in
 * the brand colour right under the rings, so it is hidden while focused.
 */
export const HotspotFocusScope = styled.divBox`
  & > button:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 3px var(--color-focus-ring-hotspot),
      0 0 0 6px var(--color-white),
      0 0 0 8px var(--color-black);
    z-index: 3;
  }

  &:has(> button:focus-visible) > .drillBoxEffect {
    visibility: hidden;
  }
`;
